// extracted by mini-css-extract-plugin
export default {"already":"Auth_already__7J0GP"};